/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  GetAcsTokenParams,
  GetWhoElseInCallParams,
  IsExpertInCallParams,
  ResponseAcsAcsChatFile,
  ResponseAcsGetWhoElseInCallResponse,
  ResponseAzureCommunicationServiceToken,
  UploadChatAttachmentPayload,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class VideoCalling<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags VideoCalling
   * @name GetAcsToken
   * @summary Get Azure Communication Services token for the current user (Auth policies: GuestOrClientOrExpertPolicy)
   * @request GET:/api/v1/video-calling/token
   * @secure
   * @response `200` `ResponseAzureCommunicationServiceToken` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getAcsToken = (query: GetAcsTokenParams, params: RequestParams = {}) =>
    this.http.request<ResponseAzureCommunicationServiceToken, void>({
      path: `/api/v1/video-calling/token`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags VideoCalling
   * @name GetChatAttachment
   * @summary  (Auth policies: GuestOrClientOrExpertPolicy)
   * @request GET:/api/v1/video-calling/chat/{chatThreadId}/attachments/{fileName}
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getChatAttachment = (
    chatThreadId: string,
    fileName: string,
    params: RequestParams = {},
  ) =>
    this.http.request<void, void>({
      path: `/api/v1/video-calling/chat/${chatThreadId}/attachments/${fileName}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags VideoCalling
   * @name GetWhoElseInCall
   * @summary Get list of users in the call except the current user (Auth policies: GuestOrClientOrExpertPolicy)
   * @request GET:/api/v1/video-calling/who-else-in-call
   * @secure
   * @response `200` `(ResponseAcsGetWhoElseInCallResponse)[]` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getWhoElseInCall = (
    query: GetWhoElseInCallParams,
    params: RequestParams = {},
  ) =>
    this.http.request<ResponseAcsGetWhoElseInCallResponse[], void>({
      path: `/api/v1/video-calling/who-else-in-call`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags VideoCalling
   * @name IsExpertInCall
   * @summary Returns if an Expert is in this call (Auth policies: GuestOrClientOrExpertPolicy)
   * @request GET:/api/v1/video-calling/expert-in-call
   * @secure
   * @response `200` `boolean` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  isExpertInCall = (query: IsExpertInCallParams, params: RequestParams = {}) =>
    this.http.request<boolean, void>({
      path: `/api/v1/video-calling/expert-in-call`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags VideoCalling
   * @name UploadChatAttachment
   * @summary  (Auth policies: GuestOrClientOrExpertPolicy)
   * @request POST:/api/v1/video-calling/chat/{chatThreadId}/attachments
   * @secure
   * @response `200` `ResponseAcsAcsChatFile` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  uploadChatAttachment = (
    chatThreadId: string,
    data: UploadChatAttachmentPayload,
    params: RequestParams = {},
  ) =>
    this.http.request<ResponseAcsAcsChatFile, void>({
      path: `/api/v1/video-calling/chat/${chatThreadId}/attachments`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
}
